module.exports = __webpack_public_path__ + "img/image-home-step03.0a052415.png";